module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_7016.bd92c11f.png";